// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rE8L","icon":"styles_icon__EBie6"};